import React, { useState } from "react";
import { HiMenuAlt3 } from "react-icons/hi";
import { MdOutlineExplore, MdOutlineAddCircleOutline } from "react-icons/md";
import { AiOutlineHome, AiOutlineUser } from "react-icons/ai";
import { FaBlog } from "react-icons/fa";
import { RiTeamLine, RiContactsLine } from "react-icons/ri";
import { Link } from "react-router-dom";

const Sidebar = ({ children }) => {
  const menus = [
    { name: "Home", link: "/", icon: AiOutlineHome },
    { name: "Explore", link: "/explore", icon: MdOutlineExplore },
    { name: "Create", link: "/create", icon: MdOutlineAddCircleOutline },
    { name: "Profile", link: "/profile", icon: AiOutlineUser, margin: true },
    // { name: "Blog", link: "/blog", icon: FaBlog },
    // { name: "About Us", link: "/about-us", icon: RiTeamLine, margin: true },
    { name: "Contact Us", link: "/contact-us", icon: RiContactsLine },
  ];

  let mobile = true;

  if (window.innerWidth <= 768) mobile = false; // closes the sidebar by default on mobile

  const [open, setOpen] = useState(mobile);
  return (
    <div>
      <section className="fixed flex gap-6 z-50">
        <div
          className={`bg-envolvlyGray min-h-screen ${
            open ? "w-72" : "w-16"
          } duration-500 text-gray-100 px-4`}
        >
          <div className="py-3 flex justify-end">
            <HiMenuAlt3
              size={26}
              className="cursor-pointer"
              onClick={() => setOpen(!open)}
            />
          </div>
          <div className="mt-4 flex flex-col gap-4 relative">
            {menus?.map((menu, i) => (
              <Link
                to={menu?.link}
                key={i}
                className={` ${
                  menu?.margin && "mt-5"
                } group flex items-center text-sm  gap-3.5 font-medium p-2 hover:bg-gray-800 rounded-md`}
              >
                <div>{React.createElement(menu?.icon, { size: "20" })}</div>
                <h2
                  style={{
                    transitionDelay: `${i + 3}00ms`,
                  }}
                  className={`whitespace-pre duration-500 ${
                    !open && "opacity-0 translate-x-28 overflow-hidden"
                  }`}
                >
                  {menu?.name}
                </h2>
                <h2
                  className={`${
                    open && "hidden"
                  } absolute left-48 bg-white font-semibold whitespace-pre text-gray-900 rounded-md drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-2 group-hover:py-1 group-hover:left-14 group-hover:duration-300 group-hover:w-fit z-[10000] `}
                >
                  {menu?.name}
                </h2>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <div className={`${open && "ml-72"} ${!open && "ml-16"} duration-500`}>
        {children}
      </div>
    </div>
  );
};

export default Sidebar;
